import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Stack, Typography } from '@mui/material';

const ContadorPasajeros = ({ title, description, setQuantity, quantity, max }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '20px',
    }}
  >
    <Stack direction='column'>
      <Typography>{title}</Typography>
      <Typography fontSize={12}>{description}</Typography>
    </Stack>
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <div
        style={{
          backgroundColor: '#4f4f4f',
          borderTopLeftRadius: 8,
          borderBottomLeftRadius: 8,
          padding: 2,
        }}
      >
        <RemoveIcon
          height={30}
          width={30}
          style={{ fill: 'white' }}
          onClick={() => {
            const minQuantity = title === 'Adultos' ? 1 : 0;
            if (quantity > minQuantity) {
              setQuantity(quantity - 1);
            }
          }}
        />
      </div>
      <div
        style={{
          height: 30,
          width: 30,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {quantity}
      </div>
      <div
        style={{
          backgroundColor: '#4f4f4f',
          borderTopRightRadius: 8,
          borderBottomRightRadius: 8,
          padding: 2,
        }}
      >
        <AddIcon
          onClick={() => {
            if (!max || (max && quantity < max)) setQuantity(quantity + 1);
          }}
          style={{ fill: 'white' }}
        />
      </div>
    </Stack>
  </div>
);

export default ContadorPasajeros;
